module.exports = __webpack_public_path__ + "img/s10-person.abe49714.png";